import { createFileRoute } from "@tanstack/react-router";

import { ReviewersPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/reviewers")({
  component: ReviewersPage,
});
